import velocity from 'velocity-animate';

export function scrollToTop(element, complete) {
  const time = element.scrollTop / 2;
  velocity(element, 'scroll', time, complete);
}

export function scrollIntoView(element, container, axis, options) {
  velocity(element, 'scroll', {container, axis, duration: 1000, ...options});
}

export function getScrollingElement() {
  return document.scrollingElement || document.documentElement || document.body;
}
